import React, { useEffect, useState } from "react";
import { CardContainer } from "../../components/Card/CardContainer";
import {
  Alert,
  Badge,
  Card,
  Checkbox,
  Col,
  ConfigProvider,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Table,
  Tabs,
  Tag,
} from "antd";
import Permission from "../../components/Permission/Permission";
import Button from "../../components/Button/Button";
import { useNavigate } from "react-router-dom";
import Text from "../../components/Text/Text";
import { color, icon } from "../../resource";
import Collapse from "../../components/Collapse/collapse";
import { DownOutlined, RightOutlined, SearchOutlined, TeamOutlined } from "@ant-design/icons";
import { ActionBtnWhite } from "../../components/Button/TableActionButton";
import { TimeLineStyled } from "./CreateAdvanceCreditSetting";
import styled from "styled-components";
import { FlexCol } from "../../components/Container/Container";
import {
  deleteRule,
  getAllRule,
  getApproveDetail,
  getShopDetailInRule,
} from "../../datasource/AdvanceCreditAppoveDatasource";
import dayjs from "dayjs";
import { useMessageContext } from "../../context/MessageProvider";
import { useEffectOnce } from "react-use";
import { getShopGroup } from "../../datasource/ShopGroupDatasoure";
import { zoneDatasource } from "../../datasource/ZoneDatasource";

const StyledIndexCollapse = styled(Collapse)`
  .advance-credit-collapse-panel .ant-collapse-content-box {
    padding: 16px 20px !important;
  }
`;
const StyleTag = styled(Tag)`
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${color.primary} !important;
  }
`;

export const IndexAdvanceCreditSetting: React.FC = () => {
  const navigate = useNavigate();
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [data, setData] = useState<any>({ total: 0, data: [], updateBy: "", updateDate: "" });
  const [loading, setLoading] = useState<boolean>(false);
  const [detailShopModal, setDetailShopModal] = useState<any>({
    open: false,
    teams: null,
    ruleName: "",
    ruleId: "",
  });
  const [deleteRuleModal, setDeleteRuleModal] = useState<{
    open: boolean;
    ruleId: string;
    ruleName?: string;
  }>({
    open: false,
    ruleId: "",
    ruleName: "",
  });
  const [detailApproveModal, setDetailApproveModal] = useState<{
    open: boolean;
    ruleConId?: string;
  }>({ open: false, ruleConId: "" });

  const { messageApi } = useMessageContext();

  const fetchData = async () => {
    setLoading(true);
    await getAllRule(profile.company).then((res) => {
      setData({
        total: res.total,
        data: res.data,
        updateBy: res.updateBy,
        updateDate: res.updateDate,
      });
    });
    setTimeout(() => {
      setLoading(false);
    }, 300);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const PageTitle = () => {
    return (
      <Row justify={"space-between"} gutter={16}>
        <Col>
          <div>
            <span
              className='card-label font-weight-bolder text-dark'
              style={{ fontSize: 20, fontWeight: "bold" }}
            >
              กฎการอนุมัติวงเงินเกิน
            </span>
          </div>
        </Col>
        <Permission permission={["ruleAdvanceCreditLimit", "create"]}>
          <Col>
            <Button
              type='primary'
              title='+ สร้างกฎการอนุมัติ'
              height={40}
              onClick={() => navigate("/order/create-advance-credit-limit/0")}
              size='large'
            />
          </Col>
        </Permission>
      </Row>
    );
  };

  const CollapseHeader = ({ header }: { header: any }) => {
    return (
      <div style={{ padding: "20px" }}>
        <Row justify={"space-between"}>
          <Col span={22}>
            <Row>
              <Col>
                <Text fontWeight={600} level={4}>
                  {header.ruleName}
                </Text>
              </Col>
            </Row>
            <Row style={{ paddingBottom: "8px" }}>
              <Col>
                <Text color='Text3'>{header.ruleDescription}</Text>
              </Col>
            </Row>
            <Row justify={"start"} gutter={8} style={{ paddingBottom: "8px" }}>
              <Col>
                <Tag
                  color={color.white}
                  style={{ borderRadius: "20px", borderColor: color.primary }}
                >
                  <Text fontSize={14} fontWeight={600} color='primary'>
                    {header?.condition?.length} ลำดับ
                  </Text>
                </Tag>
              </Col>
              <Col>
                <Row gutter={16}>
                  <Col>
                    <Text color='Text3' fontSize={16}>
                      ทีมที่ใช้กฎนี้ : {header?.team?.length === 0 ? "-" : ""}
                    </Text>
                  </Col>
                  <Col>
                    <div
                      onClick={() => {
                        setDetailShopModal({
                          open: true,
                          teams: header?.team,
                          ruleName: header.ruleName,
                          ruleId: header.ruleId,
                        });
                      }}
                    >
                      <Row>
                        {header?.team?.map((team: any, index: number) => (
                          <Col key={team.teamId}>
                            <TagTeamComponent team={team} />
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row justify={"start"}>
              <Col>
                <Text color='Text3' level={6}>
                  {`อัปเดตล่าสุด ${dayjs(header.updateDate).format("DD/MM/YYYY, HH:mm")} โดย ${header.updateBy}`}
                </Text>
              </Col>
            </Row>
          </Col>
          <Col
            span={2}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Row justify={"end"} gutter={8}>
              <Col>
                <Permission permission={["ruleAdvanceCreditLimit", "edit"]}>
                  <ActionBtnWhite
                    icon={<img src={icon.writeIcon} style={{ width: 14, height: 16 }} />}
                    onClick={() => navigate(`/order/create-advance-credit-limit/${header.ruleId}`)}
                  />
                </Permission>
              </Col>
              <Col>
                <Permission permission={["ruleAdvanceCreditLimit", "delete"]}>
                  <ActionBtnWhite
                    icon={<img src={icon.delete} style={{ width: 14, height: 16 }} />}
                    onClick={() =>
                      setDeleteRuleModal({
                        open: true,
                        ruleId: header.ruleId,
                        ruleName: header.ruleName,
                      })
                    }
                  />
                </Permission>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  };

  const deleteRuleById = async (ruleId: string, updateBy: string) => {
    await deleteRule(ruleId, updateBy).then((res) => {
      if (res.success) {
        fetchData();
        messageApi.open({
          type: "error",
          content: "ลบรายการแล้ว",
          icon: <img src={icon.delete} style={{ width: 14, height: 16 }} />,
        });
      }
    });
  };

  return (
    <>
      <CardContainer>
        {PageTitle()}
        <br />
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80vh",
            }}
          >
            <Spin size='large' />
          </div>
        ) : (
          <>
            {data?.total > 0 ? (
              <>
                <Row justify={"end"} gutter={16} style={{ marginBottom: 20 }}>
                  <Col>
                    <Text level={6}>{data?.total} รายการ</Text>
                  </Col>
                </Row>
                {data?.data.map((item: any, ruleIndex: number) => {
                  const loopSequence = (num: number) => {
                    const sequence: any = [];
                    const findData = data.data[ruleIndex];
                    for (let i = 1; i <= num; i++) {
                      sequence.push(findData?.condition[i - 1]);
                    }
                    return sequence;
                  };
                  return (
                    <>
                      <StyledIndexCollapse
                        key={item.id}
                        iconPadding={"30px 10px"}
                        backgroundColor={"#F3F6F9"}
                        paddingContentSpecial={"none"}
                        defaultActiveKey={1}
                        collapsible='icon'
                        expandIconPosition='end'
                        expandIcon={({ isActive }) => (
                          <DownOutlined
                            style={{
                              color: color.Text1,
                              fontSize: 16,
                            }}
                            rotate={isActive ? 180 : 0}
                          />
                        )}
                      >
                        <Collapse.Panel
                          header={<CollapseHeader header={item} />}
                          key={1}
                          className='custom-collapse'
                        >
                          <TimeLineStyled
                            mode='left'
                            items={item.condition.map((con, conIndex) => ({
                              dot: (
                                <Badge
                                  key={conIndex + 1}
                                  count={conIndex + 1}
                                  color='#1B4586'
                                  style={{
                                    width: 20,
                                    height: 20,
                                    lineHeight: "20px",
                                    borderRadius: "50%",
                                    fontSize: 12,
                                  }}
                                />
                              ),
                              color: conIndex === 0 ? "green" : "blue",
                              children: (
                                <SequnceDetail
                                  detail={con}
                                  sequence={loopSequence(con.groupNo)}
                                  limitPercent={item?.limitCreditPercent}
                                  setDetailApproveModal={setDetailApproveModal}
                                />
                              ),
                            }))}
                          />
                        </Collapse.Panel>
                      </StyledIndexCollapse>
                      <br />
                    </>
                  );
                })}
              </>
            ) : (
              <div
                style={{
                  padding: 32,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 24,
                  minHeight: 600,
                }}
              >
                <img
                  src={icon.emptyHistoryPoint}
                  style={{
                    width: 80,
                    height: 90,
                    alignItems: "center",
                  }}
                  alt='empty_table'
                />

                <Text
                  fontFamily='Sarabun'
                  fontSize={16}
                  fontWeight={400}
                  color='Text3'
                  align='center'
                >
                  {`ยังไม่ได้กำหนดกฎการอนุมัติ`}
                  <br />
                  {`คลิก "สร้างกฎการอนุมัติ" เพื่อสร้างกฎใหม่`}
                </Text>
              </div>
            )}
          </>
        )}
      </CardContainer>
      {detailShopModal.open && (
        <ModalShopDetail
          detailShopModal={detailShopModal}
          setDetailShopModal={setDetailShopModal}
        />
      )}
      {detailApproveModal.open && (
        <ModalApproveDetail
          data={detailApproveModal}
          setDetailApproveModal={setDetailApproveModal}
        />
      )}
      {deleteRuleModal.open && (
        <Modal
          open={deleteRuleModal.open}
          centered
          closable={false}
          onCancel={() => setDeleteRuleModal({ open: false, ruleId: "", ruleName: "" })}
          onOk={() => {
            deleteRuleById(deleteRuleModal.ruleId, profile?.firstname + " " + profile?.lastname);
            setDeleteRuleModal({ open: false, ruleId: "", ruleName: "" });
          }}
          okText='ลบกฎนี้'
          cancelText='ยกเลิก'
          okButtonProps={{ danger: true }}
          cancelButtonProps={{ style: { borderColor: color.error, color: color.error } }}
        >
          <Text level={2}>ยืนยันลบกฎการอนุมัติ</Text>
          <br />
          <Text level={2}>{`"${deleteRuleModal.ruleName}"`}</Text>
          <br />
          <Text color='error' fontWeight={600}>
            ผลที่จะเกิดขึ้นทันที
          </Text>{" "}
          &nbsp;
          <Text color='error'>
            ร้านค้าที่ใช้กฎนี้จะไม่สามารถสั่งซื้อเกินวงเงินได้อีกต่อไป ระบบจะดำเนินการปิดอัตโนมัติ
          </Text>
          <div style={{ paddingTop: "8px" }}>
            <Alert
              message={
                <Text level={6}>
                  คำสั่งซื้อที่อยู่ระหว่างการพิจารณาวงเงินยังดำเนินต่อได้ตามปกติ
                  และจะใช้เงื่อนไขของกฎนี้จนกว่าการพิจารณาจะเสร็จสิ้น
                </Text>
              }
              style={{ backgroundColor: "#F3F6F9", borderColor: "#F3F6F9" }}
              showIcon
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export const SequnceDetail = ({
  sequence,
  detail,
  limitPercent,
  setDetailApproveModal,
}: {
  detail: any;
  limitPercent: any;
  sequence: any;
  setDetailApproveModal?: any;
}) => {
  const isLimit = parseFloat(detail?.max) === parseFloat(limitPercent) ? true : false;
  return (
    <div>
      <Card style={{ backgroundColor: "#FAFAFA" }} bodyStyle={{ padding: "10px" }}>
        <Row justify={"start"} gutter={16}>
          <Col span={2}>
            <Tag
              color={color.white}
              style={{
                borderRadius: "20px",
                backgroundColor: "#E6EEFA",
                borderColor: detail?.statusCustomMax ? color.warning : "#E6EEFA",
              }}
            >
              <Text fontSize={12} fontWeight={600}>
                {detail.max ? `${detail.min}% - ${detail.max}%` : `> ${detail.min}%`}
              </Text>
            </Tag>
          </Col>
          <Col>
            {sequence.map((item: any, index: number) => (
              <>
                <StyleTag
                  onClick={() =>
                    setDetailApproveModal({ open: true, ruleConId: item.ruleConditionsId })
                  }
                  style={{ cursor: "pointer" }}
                >
                  <TeamOutlined
                    style={{
                      transform: "scaleY(-1)  rotate(180deg)",
                      fontSize: "14px",
                    }}
                  />
                  <Text fontSize={12} fontWeight={600}>
                    {item.roleName}
                  </Text>{" "}
                  <Text fontSize={12} fontWeight={400} color='Text3'>
                    {item.approveType === "ALL" ? `(ทั้งหมด)` : `(ขั้นต่ำ ${item.maximumApproval})`}
                  </Text>
                </StyleTag>
                {sequence.length !== index + 1 && <RightOutlined style={{ fontSize: "12px" }} />}{" "}
                &nbsp;
              </>
            ))}
          </Col>
        </Row>
      </Card>
      {isLimit && (
        <>
          <br />
          <Card
            bodyStyle={{
              padding: "10px",
            }}
            style={{
              backgroundColor: "#FAFAFA",
              borderRadius: 8,
            }}
          >
            <Row
              align='middle'
              style={{
                height: "100%",
              }}
            >
              <Col span={2}>
                <div
                  style={{
                    width: 80,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: 2,
                      background: detail?.statusCustomMax ? color.warning : "#8B97A8",
                    }}
                  />

                  <Text level={6} fontWeight={600} color='BK'>
                    {limitPercent} %
                  </Text>
                </div>
              </Col>
              <Col>
                <Text level={6} fontWeight={400} color='BK'>
                  เพดานวงเงินเกิน
                </Text>
              </Col>
            </Row>
          </Card>
        </>
      )}
    </div>
  );
};

export const ModalApproveDetail = ({
  data,
  setDetailApproveModal,
}: {
  data: any;
  setDetailApproveModal: any;
}) => {
  const [detail, setDetail] = useState<any>();

  const getApproveSequence = async () => {
    const res = await getApproveDetail(data.ruleConId).then((res) => res);
    setDetail(res);
  };
  useEffect(() => {
    getApproveSequence();
  }, [data.ruleConId]);

  return (
    <Modal
      open={data.open}
      footer={false}
      title={
        <>
          <Text fontWeight={600} level={4}>{`ลำดับที่ ${detail?.groupNo}`}</Text>
          <br />
          <Text level={5} color='Text3'>
            {detail?.ruleName}
          </Text>
        </>
      }
      centered
      onCancel={() => setDetailApproveModal({ ...data, open: false })}
    >
      <Row>
        <Text level={6} fontWeight={600}>
          รายละเอียด
        </Text>
      </Row>
      <Card
        style={{ backgroundColor: "#FAFAFA" }}
        bodyStyle={{
          paddingTop: "10px",
          paddingBottom: "10px",
        }}
      >
        <Row justify={"space-around"} gutter={16}>
          <Col span={12}>
            <Text level={6}>บทบาทที่ต้องอนุมัติ</Text>
          </Col>
          <Col span={12}>
            <Text level={6}>{detail?.roleName}</Text>
          </Col>
        </Row>
        <Row justify={"space-around"} gutter={16}>
          <Col span={12}>
            <Text level={6}>รูปแบบการอนุมัติ</Text>
          </Col>
          <Col span={12}>
            <Text level={6}>
              {detail?.approveType === "ALL" ? "ทุกคนต้องอนุมัติ" : "อนุมัติตามจำนวนขั้นต่ำ"}
            </Text>
          </Col>
        </Row>
        {detail?.approveType === "MINIMUM" && (
          <Row justify={"space-around"} gutter={16}>
            <Col span={12}>
              <Text level={6}>จำนวนขั้นต่ำที่ต้องอนุมัติ</Text>
            </Col>
            <Col span={12}>
              <Text level={6}>{detail?.maximumApproval} คน</Text>
            </Col>
          </Row>
        )}
      </Card>
      <br />
      <Row>
        <Text level={6} fontWeight={600}>
          รายชื่อผู้อนุมัติ
        </Text>
      </Row>
      <Card
        style={{ backgroundColor: "#FAFAFA" }}
        bodyStyle={{
          maxHeight: 400,
          overflowY: "auto",
          paddingTop: "10px",
          paddingLeft: "20px",
          paddingBottom: "10px",
        }}
      >
        {detail?.approvers.map((approver: any, index: number) => (
          <Row justify={"space-around"} gutter={16} key={index} style={{ marginBottom: "5px" }}>
            <Col span={12}>
              <Text level={6}>ผู้อนุมัติคนที่ {index + 1}</Text>
            </Col>
            <Col span={12}>
              <Text level={6}>{approver?.fullName}</Text>
            </Col>
          </Row>
        ))}
      </Card>
    </Modal>
  );
};

export const TagTeamComponent = ({ team }: { team: any }) => {
  return (
    <StyleTag
      color={color.white}
      style={{ borderRadius: "5px", borderColor: color.Text3, cursor: "pointer" }}
      //onClick={() => setDetailShopModel(true)}
    >
      <Row justify={"start"} gutter={8}>
        <Col>
          <Text fontSize={14} fontWeight={600} color='black'>
            {team.teamName}
          </Text>
        </Col>
        <Col>
          <img src={icon.store} style={{ height: "13px" }} />
        </Col>
        <Col>
          <Text fontSize={14} fontWeight={400} color='primary'>
            {team.shopCount}
            {team.countAll ? `/${team.countAll}` : ""} ร้านค้า
          </Text>
        </Col>
        <RightOutlined style={{ color: color.BK, fontSize: 10 }} />
      </Row>
    </StyleTag>
  );
};

export const ModalShopDetail = ({
  detailShopModal,
  setDetailShopModal,
}: {
  detailShopModal: any;
  setDetailShopModal: any;
}) => {
  const [activeTeamKey, setActiveTeamKey] = useState<string>("");
  const [resetSearchTrigger, setResetSearchTrigger] = useState<number>(0);

  useEffect(() => {
    const firstTeamId = detailShopModal?.teams?.[0]?.teamId || "";
    setActiveTeamKey(firstTeamId);
    setResetSearchTrigger((prev) => prev + 1);
  }, [detailShopModal?.open, detailShopModal?.teams]);

  return (
    <>
      {detailShopModal.open && (
        <Modal
          open={detailShopModal.open}
          footer={false}
          title={
            <Text fontWeight={600} level={4}>
              {detailShopModal?.ruleName}
            </Text>
          }
          centered
          width={800}
          onCancel={() => setDetailShopModal({ ...detailShopModal, open: false })}
        >
          <Tabs
            activeKey={activeTeamKey}
            onChange={(key: any) => {
              setActiveTeamKey(key);
              setResetSearchTrigger((prev) => prev + 1);
            }}
            items={(detailShopModal?.teams as any)?.map((team: any, index: number) => ({
              key: team?.teamId,
              label: `${team?.teamName} (${team?.shopCount} ร้าน)`,
              children: (
                <RuleShopDetail
                  team={team}
                  ruleId={detailShopModal?.ruleId}
                  resetTrigger={resetSearchTrigger}
                  key={team?.teamId}
                />
              ),
            }))}
          />
        </Modal>
      )}
    </>
  );
};

export const RuleShopDetail = ({
  team,
  ruleId,
  resetTrigger,
}: {
  team: any;
  ruleId: string;
  resetTrigger: number;
}) => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [teamId, setTeamId] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [dataShop, setDataShop] = useState<any>([]);
  const [customerGroup, setCustomerGroup] = useState<any>([]);
  const [zone, setZone] = useState<any>([]);
  const [search, setSearch] = useState<any>(undefined);
  const [searchCusGroup, setSearchCusGroup] = useState<any>(undefined);
  const [searchZone, setSearchZone] = useState<any>(undefined);

  const shopDetail = async () => {
    setTeamId(team?.teamId);
    const res = await getShopDetailInRule({
      teamId: team?.teamId,
      ruleId: ruleId,
      page: 0,
      take: 0,
      searchText: search,
      customerGroupName: searchCusGroup,
      zone: searchZone,
    });
    setDataShop(res);
  };

  const fetchCustomerGroup = async () => {
    const res = await getShopGroup({
      company: profile.company,
      page: 1,
      take: 100,
    });
    const mapGroup = res?.responseData?.data?.map((group: any) => ({
      label: group?.customerGroupName,
      value: group?.customerGroupName,
      key: group?.customerGroupName,
    }));
    setCustomerGroup(mapGroup);
  };

  const fetchZone = async () => {
    const res = await zoneDatasource.getAllZoneByCompany(profile?.company);
    const mapZone = res?.map((z: any) => ({
      label: z?.zoneName,
      value: z?.zoneName,
      key: z?.zoneName,
    }));
    setZone(mapZone);
  };

  useEffectOnce(() => {
    fetchCustomerGroup();
    fetchZone();
  });

  useEffect(() => {
    setSearch("");
    setSearchCusGroup(undefined);
    setSearchZone(undefined);
  }, [resetTrigger]);

  useEffect(() => {
    setLoading(true);
    setTeamId((prev) => {
      if (prev !== teamId) {
        setSearch(undefined);
        setSearchCusGroup(undefined);
        setSearchZone(undefined);
      }
      return team?.teamId;
    });
    shopDetail();
    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, [team?.teamId, ruleId, search, searchCusGroup, searchZone]);

  const columns = [
    {
      title: "รหัสร้านค้า",
      dataIndex: "customerNo",
      key: "customerNo",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text fontFamily='Sarabun'>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "40%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text fontFamily='Sarabun'>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text fontFamily='Sarabun'>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "กลุ่มลูกค้า",
      dataIndex: "customerGroupName",
      key: "customerGroupName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text fontFamily='Sarabun'>{value || "-"} </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "statusCustom",
      key: "statusCustom",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              {!value ? (
                <Tag style={{ borderRadius: "20px" }}>
                  <Text fontSize={12} fontWeight={600}>
                    ค่าเริ่มต้น
                  </Text>
                </Tag>
              ) : (
                <Tag style={{ borderRadius: "20px", borderColor: color.warning }}>
                  <Badge color={color.warning} />
                  &nbsp;
                  <Text fontSize={12} fontWeight={600} color='warning'>
                    ปรับแต่ง
                  </Text>
                </Tag>
              )}
            </FlexCol>
          ),
        };
      },
    },
  ];

  return (
    <>
      <div style={{ paddingBottom: "10px" }}>
        <Input
          suffix={<SearchOutlined />}
          placeholder='ค้นหารหัส / ชื่อร้านค้า'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <Row style={{ paddingBottom: "10px" }} justify={"space-between"} gutter={8}>
        <Col span={5}>
          <Select
            mode='multiple'
            allowClear
            options={customerGroup}
            style={{ width: "100%" }}
            placeholder='กลุ่มลูกค้า'
            value={searchCusGroup}
            onChange={setSearchCusGroup}
            showSearch={false}
            menuItemSelectedIcon={null}
            maxTagCount={0}
            tagRender={({ value, closable, onClose }) => {
              return (
                <Row justify={"space-between"} gutter={16} style={{ paddingLeft: "6px" }}>
                  <Col>
                    <Text level={6}>กลุ่มลูกค้า</Text>
                  </Col>
                  <Col>
                    <Badge
                      count={searchCusGroup?.length}
                      style={{ backgroundColor: "#FFF4E6", color: "#faad14", fontWeight: "bold" }}
                    />
                  </Col>
                </Row>
              );
            }}
            optionRender={(option: any) => {
              return (
                <Row justify={"space-between"}>
                  <Col>
                    <Checkbox checked={searchCusGroup?.includes(option.value)}>
                      {option.label}
                    </Checkbox>
                  </Col>
                </Row>
              );
            }}
          />
        </Col>
        <Col span={4}>
          <Select
            options={zone || []}
            mode='multiple'
            allowClear
            value={searchZone}
            style={{ width: "100%" }}
            placeholder='เขต'
            onChange={(e) => setSearchZone(e)}
            menuItemSelectedIcon={null}
            showSearch={false}
            maxTagCount={0}
            tagRender={({ value, closable, onClose }) => {
              return (
                <Row justify={"space-between"} gutter={16} style={{ paddingLeft: "5px" }}>
                  <Col>
                    <Text level={6}>เขต</Text>
                  </Col>
                  <Col>
                    <Badge
                      count={searchZone?.length}
                      style={{ backgroundColor: "#FFF4E6", color: "#faad14", fontWeight: "bold" }}
                    />
                  </Col>
                </Row>
              );
            }}
            optionRender={(option: any) => {
              return (
                <Row justify={"space-between"}>
                  <Col>
                    <Checkbox checked={searchZone?.includes(option.value)}>{option.label}</Checkbox>
                  </Col>
                </Row>
              );
            }}
          />
        </Col>
        <Col span={12} style={{ paddingTop: "6px" }}>
          <Text
            color='primary'
            fontSize={14}
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSearch("");
              setSearchCusGroup(undefined);
              setSearchZone(undefined);
            }}
          >
            ล้างทั้งหมด
          </Text>
        </Col>
        <Col span={3} style={{ paddingTop: "4px" }}>
          {dataShop?.total > 0 && <Text level={6}>{dataShop?.total} รายการ</Text>}
        </Col>
      </Row>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
            },
          },
        }}
      >
        <Table
          loading={loading}
          columns={columns}
          size='small'
          dataSource={dataShop?.data || []}
          style={{ width: "100%", height: "400px" }}
          scroll={{ y: 360 }}
          pagination={false}
        />
      </ConfigProvider>
    </>
  );
};
